export type AccountKind = "proveedor" | "cliente" | "general";

/** Decide en qué maestro vive una subcuenta según su grupo del PGC. */
export const kindForAccount = (account: string): AccountKind => {
  const a = account.trim();
  if (/^4[01]/.test(a)) return "proveedor";
  if (/^4[34]/.test(a)) return "cliente";
  return "general";
};

export type AccountGroupFilter = "todos" | "proveedores" | "clientes" | "tesoreria" | "gastos_ingresos" | "otros";

export const matchesGroupFilter = (account: string, f: AccountGroupFilter): boolean => {
  const a = account.trim();
  switch (f) {
    case "todos": return true;
    case "proveedores": return /^4[01]/.test(a);
    case "clientes": return /^4[34]/.test(a);
    case "tesoreria": return /^5/.test(a);
    case "gastos_ingresos": return /^[67]/.test(a);
    case "otros": return !/^(4[0134]|5|6|7)/.test(a);
  }
};

export interface PickableAccount { account: string; name: string; taxId?: string; kind: AccountKind }

/** Busca cuentas por número (prefijo), razón social o NIF. Ordena: prefijo de cuenta primero. */
export const searchAccounts = (list: PickableAccount[], query: string, limit = 50): PickableAccount[] => {
  const strip = (s: string) => s.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toUpperCase();
  const q = strip(query.trim());
  if (!q) return list.slice(0, limit);
  const qTax = q.replace(/^ES/, "").replace(/[^A-Z0-9]/g, "");
  const scored: { a: PickableAccount; s: number }[] = [];
  for (const a of list) {
    let s = -1;
    if (a.account.startsWith(q)) s = 0;
    else if (strip(a.name).includes(q)) s = 1;
    else if (qTax.length >= 3 && a.taxId && strip(a.taxId).replace(/[^A-Z0-9]/g, "").includes(qTax)) s = 2;
    else if (a.account.includes(q)) s = 3;
    if (s >= 0) scored.push({ a, s });
  }
  return scored.sort((x, y) => x.s - y.s || x.a.account.localeCompare(y.a.account)).slice(0, limit).map((x) => x.a);
};
